import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as FORUM_TOPIC_TYPE} from '../creators/forums.topic';

export function* createSuccess(action) {
    try {
        yield put({type: "FORUM_TOPICS_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "FORUM_TOPICS_DELETE", data : action.payload});
    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "FORUM_TOPICS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchTopic() {
    yield takeEvery(FORUM_TOPIC_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(FORUM_TOPIC_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(FORUM_TOPIC_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchTopic;

